import React, { createContext, use, useContext, useEffect, useState } from "react";
import { findClientByHost } from "../services/ClientService";

export const WhiteLabelContext = createContext();

export const useClient = () => useContext(WhiteLabelContext);

const WhiteLabelProvider = (props) => {
  const [whiteLabel, setWhiteLabel] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [theme, setTheme] = useState(null);
  const [images, setImages] = useState(null);
  const [aboutUs, setAboutUs] = useState(null);
  const [language, setLanguage] = useState(null);

  useEffect(() => {
    console.log("theme111", theme);
    async function loadTheme() {
      await fetchClientConfig();
    }

    async function loadCssVariables() {
      await setCssVariables(theme);
    }

    if (theme) loadCssVariables();
    else loadTheme();
  }, [theme]);

  const fetchClientConfig = async () => {
    try {
      setLoading(true);
      const hostname = window.location.hostname; // Captura o host atual
      console.log("Fetching whiteLabel configuration for host:", hostname);
      const response = await findClientByHost(hostname); // Busca as configurações do whiteLabele
      console.log("Client configuration response:", response);
      setTheme(response.json_style.colors);
      setLanguage(response.json_style.language);
      setImages(response.json_style.images);
      setWhiteLabel(response); // Configurações do whiteLabele
      
      // Verifica se existe icons no json_style, senão usa o icon_url legado
      if (response.json_style.icons) {
        updateFavicons(response.json_style.icons);
      } else if (response.icon_url) {
        updateFavicon(response.icon_url);
      }
      
      fetchTheme(response); // Busca o tema do whiteLabele
      setAboutUs(response.json_about_us);
      setError(null);
    } catch (err) {
      console.error("Failed to fetch whiteLabel configuration:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  const updateFavicons = (icons) => {
    // Remove todos os favicons existentes primeiro
    const existingIcons = document.querySelectorAll('link[rel*="icon"], link[rel*="apple-touch-icon"], meta[name="msapplication-TileImage"]');
    existingIcons.forEach((icon) => icon.parentNode.removeChild(icon));
    
    // Adiciona favicon padrão (para navegadores mais antigos)
    if (icons.favicon) {
      const favicon = document.createElement("link");
      favicon.rel = "icon";
      favicon.href = icons.favicon;
      document.head.appendChild(favicon);
    }
    
    // Adiciona favicon no formato .ico (para IE)
    if (icons.ico) {
      const icoIcon = document.createElement("link");
      icoIcon.rel = "shortcut icon";
      icoIcon.type = "image/x-icon";
      icoIcon.href = icons.ico;
      document.head.appendChild(icoIcon);
    }
    
    // Adiciona favicons SVG (formato moderno e escalonável)
    if (icons.svg) {
      const svgIcon = document.createElement("link");
      svgIcon.rel = "icon";
      svgIcon.type = "image/svg+xml";
      svgIcon.href = icons.svg;
      document.head.appendChild(svgIcon);
    }
    
    // Adiciona os ícones para Apple devices (iOS/Safari)
    if (icons.appleTouchIcons) {
      Object.entries(icons.appleTouchIcons).forEach(([size, url]) => {
        const appleIcon = document.createElement("link");
        appleIcon.rel = "apple-touch-icon";
        appleIcon.sizes = size; // Por exemplo: "180x180"
        appleIcon.href = url;
        document.head.appendChild(appleIcon);
      });
    }
    
    // Adiciona o ícone principal para Apple Touch (se existir separadamente)
    if (icons.appleTouch) {
      const appleTouchIcon = document.createElement("link");
      appleTouchIcon.rel = "apple-touch-icon";
      appleTouchIcon.href = icons.appleTouch;
      document.head.appendChild(appleTouchIcon);
    }
    
    // Adiciona Web App Manifest (para PWA)
    if (icons.manifest) {
      const manifest = document.createElement("link");
      manifest.rel = "manifest";
      manifest.href = icons.manifest;
      document.head.appendChild(manifest);
    }
    
    // Configura ícones para Windows Tiles
    if (icons.msTileImage) {
      const msTileColor = document.createElement("meta");
      msTileColor.name = "msapplication-TileColor";
      msTileColor.content = icons.msTileColor || "#ffffff";
      document.head.appendChild(msTileColor);
      
      const msTileImage = document.createElement("meta");
      msTileImage.name = "msapplication-TileImage";
      msTileImage.content = icons.msTileImage;
      document.head.appendChild(msTileImage);
    }
    
    // Adiciona ícones para diferentes tamanhos (usados em vários contextos)
    if (icons.sizes) {
      Object.entries(icons.sizes).forEach(([size, url]) => {
        const sizedIcon = document.createElement("link");
        sizedIcon.rel = "icon";
        sizedIcon.type = "image/png";
        sizedIcon.sizes = size; // Por exemplo: "32x32"
        sizedIcon.href = url;
        document.head.appendChild(sizedIcon);
      });
    }
  };
  
  const updateFavicon = (faviconUrl) => {
    // Busca todas as tags de ícone no documento
    const links = document.querySelectorAll('link[rel*="icon"]');
    
    // Remove todas as tags existentes
    links.forEach((link) => link.parentNode.removeChild(link));
    
    // Cria uma nova tag de favicon
    const newLink = document.createElement("link");
    newLink.rel = "icon";
    newLink.href = faviconUrl;
  
    // Adiciona a nova tag ao <head>
    document.head.appendChild(newLink);
  };

  const fetchTheme = async (whiteLabel) => {
    try {
      const { json_style } = whiteLabel;
      console.log("json_style", json_style);

      if (json_style) {
        setCssVariables(json_style);
      }
    } catch (error) {
      console.log(`Theme Error => ` + error);
    }
  };

  const setCssVariables = async (partner_theme) => {
    console.log("partner_theme11", partner_theme);

    const r = document.querySelector(`:root`);

    console.log("partner_theme.primary_color", partner_theme.primary_color);
    if (partner_theme.primary_color)
      r.style.setProperty(`--k4n-primary-color`, partner_theme.primary_color);
  };

  const resetWhiteLabelContext = () => {
    setWhiteLabel(null);
    setLoading(false);
    setError(null);
  };

  return (
    <WhiteLabelContext.Provider
      value={{
        whiteLabel,
        loading,
        error,
        theme,
        language,
        images,
        aboutUs,
        fetchClientConfig,
        resetWhiteLabelContext,
      }}
    >
      {loading ? <div>Loading whiteLabel configuration...</div> : props.children}
    </WhiteLabelContext.Provider>
  );
};

export default WhiteLabelProvider;
